import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {AbstractFormGroupComponent} from '@cupoui/shared/components/abstract-form-group.component';
import {RoleService} from '@cupoui/core/user/role.service';
import {AccountService} from '@cupoui/core/auth/account.service';
import {UserService} from '@cupoui/core/user/user.service';
import {IRole} from '@cupoui/core/user/role.model';
import {Account} from '@cupoui/core/user/account.model';
import {CustomerProfiles} from '@cupoui/shared/model/customerProfiles';
import {NGXLogger} from 'ngx-logger';
import {PageType} from '@cupoui/shared/components/info-bar/info-bar.component';
import moment from 'moment';
import {SalesOrderService} from "@cupoui/core/services/sales-order.service";

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent extends AbstractFormGroupComponent implements OnInit {
  account!: Account;

  userCustomerRoles: IRole[];
  userCustomerRolesIsUpdating = false;
  showRefresh = false;

  customerProfiles: CustomerProfiles[];
  lastPage = PageType.LAST_PAGE;

  constructor(
    private accountService: AccountService,
    private roleService: RoleService,
    private userService: UserService,
    private fb: FormBuilder,
    private logger: NGXLogger,
    private salesOrderService: SalesOrderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      customerRoleNames: [{value: null, disabled: false}]
    });

    const selectedCustomerRoleNames = localStorage.getItem('selected-customer-role-names')?.split(',');
    if (selectedCustomerRoleNames?.length) {
      this.fg.controls.customerRoleNames.patchValue(selectedCustomerRoleNames);
    }

    this.subscriptions.push(
      this.accountService.identity().subscribe(account => {
        if (account) {
          this.account = account;
        }
      }),
      this.roleService.myCustomerRoles().subscribe(myCustomerRoles => {
        this.userCustomerRoles = [];
        for (const customerRole of this.account.customerRoles) {
          const foundCustomerRole = myCustomerRoles.find(role => role.customerRoleName === customerRole);
          if (foundCustomerRole) {
            this.userCustomerRoles.push(foundCustomerRole);
          }
        }
        if ( !localStorage.getItem('selected-customer-profile-codes')) {
          this.changeUserCustomerRoles(this.userCustomerRoles);
        }
      }),
      this.userService.customerProfiles(true).subscribe(customerProfiles => {
        this.customerProfiles = customerProfiles;
      })
    );
  }

  changeUserCustomerRoles(selectedUserCustomerRoles: IRole[]): void {
    this.showRefresh = false;
    this.userCustomerRolesIsUpdating = true;

    // Hvis selectedUserCustomerRoles er tom, brug this.userCustomerRoles
    const customerRoleNames = selectedUserCustomerRoles?.length > 0
      ? selectedUserCustomerRoles?.map(role => role.customerRoleName)
      : this.userCustomerRoles?.map(role => role.customerRoleName);

    const customerProfileCodes: string[] = [];
    const rolesToUse = selectedUserCustomerRoles?.length > 0 ? selectedUserCustomerRoles : this.userCustomerRoles;

    rolesToUse.forEach(role =>
      role.customerProfiles?.forEach(customerProfile => customerProfileCodes.push(customerProfile))
    );

    const customerProfileIds: string[] = [];
    if (customerProfileCodes.length) {
      for (const customerProfileCode of customerProfileCodes) {
        const foundCustomerProfile = this.customerProfiles.find(
          customerProfile => customerProfile.customerProfileCode === customerProfileCode
        );
        if (foundCustomerProfile) {
          customerProfileIds.push(foundCustomerProfile.customerProfileId);
        }
      }
    }

    customerRoleNames?.length
      ? localStorage.setItem('selected-customer-role-names', customerRoleNames.join(','))
      : localStorage.removeItem('selected-customer-role-names');
    customerProfileCodes.length
      ? localStorage.setItem('selected-customer-profile-codes', customerProfileCodes.join(','))
      : localStorage.removeItem('selected-customer-profile-codes');
    customerProfileIds.length
      ? localStorage.setItem('selected-customer-profile-ids', customerProfileIds.join(','))
      : localStorage.removeItem('selected-customer-profile-ids');
    this.salesOrderService.updateRoles('');
    this.logger.debug('changeUserCustomerRoles:result', customerRoleNames, customerProfileCodes, customerProfileIds);
    setTimeout(() => {
      this.userCustomerRolesIsUpdating = false;
      this.showRefresh = true;
    }, 500);
  }

  refresh(): void {
    setTimeout(() => (this.showRefresh = false), 500);
    window.location.reload();
  }

  toggleSidenav(): void {
    // Implement SidenavService to handle toggle notifications in e.g. main.component.ts
    // this.sidenavService.toggle();
    // sidenav.toggle()
  }

  showSnow(): boolean {
    return [0, 11].includes(moment().month()) && this.isAuthenticated();
  }

  private isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

}
